// extracted by mini-css-extract-plugin
module.exports = {"root":"SeoText-module--root--3HUtp","content":"SeoText-module--content--lX3UJ","trigger":"SeoText-module--trigger--2K68S"};